import React from 'react'
import { CaseStudy } from '../../api/Types'
import DocsCaseStudyListItem from './DocsCaseStudyListItem'
import EmptySection from '../../../common/EmptySection'

interface Props {
  readonly case_studies: ReadonlyArray<CaseStudy>
}

const DocsCaseStudyList: React.FunctionComponent<Props> = ({ case_studies }) => {
  return (
    <>
      {case_studies.length > 0 ? (
        <div className='case-study-list'>
          {case_studies.map((case_study, i) => (
            <DocsCaseStudyListItem key={i} case_study={case_study} />
          ))}
        </div>
      ) : (
        <EmptySection message={<>We couldn&#39;t find any case studies!</>} />
      )}
    </>
  )
}

export default DocsCaseStudyList
